<template>
  <MainHeader />
  <NavbarThree />
  <MainBanner />
  <WhatMakesUsDifferent />
  <MarqueeText />
  <OurSustainableApproach />
  <OurServices />
  <PoweringDailyLife />
  <PricingPlans />
  <TestOurService />
  <OurTestimonial />
  <EnjoySports />
  <FanFact />
  <CheckAvailability />
  <OurLatestArticles />
  <PartnerLogo />
  <MainFooter
    class="bg-secondary bg-img"
    :style="{ backgroundImage: `url(${bgImage})` }"
  />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import MainHeader from "@/components/Layouts/MainHeader.vue";
import NavbarThree from "@/components/Layouts/NavbarThree.vue";
import MainBanner from "@/components/SatelliteInternet/MainBanner.vue";
import WhatMakesUsDifferent from "@/components/SatelliteInternet/WhatMakesUsDifferent.vue";
import MarqueeText from "@/components/SatelliteInternet/MarqueeText.vue";
import OurSustainableApproach from "@/components/SatelliteInternet/OurSustainableApproach.vue";
import OurServices from "@/components/SatelliteInternet/OurServices.vue";
import PoweringDailyLife from "@/components/SatelliteInternet/PoweringDailyLife.vue";
import PricingPlans from "@/components/SatelliteInternet/PricingPlans.vue";
import TestOurService from "@/components/SatelliteInternet/TestOurService.vue";
import OurTestimonial from "@/components/SatelliteInternet/OurTestimonial.vue";
import EnjoySports from "@/components/SatelliteInternet/EnjoySports.vue";
import FanFact from "@/components/SatelliteInternet/FanFact.vue";
import CheckAvailability from "@/components/SatelliteInternet/CheckAvailability.vue";
import OurLatestArticles from "@/components/SatelliteInternet/OurLatestArticles.vue";
import PartnerLogo from "@/components/SatelliteInternet/PartnerLogo.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "SatelliteInternetPage",
  components: {
    MainHeader,
    NavbarThree,
    MainBanner,
    WhatMakesUsDifferent,
    MarqueeText,
    OurSustainableApproach,
    OurServices,
    PoweringDailyLife,
    PricingPlans,
    TestOurService,
    OurTestimonial,
    EnjoySports,
    FanFact,
    CheckAvailability,
    OurLatestArticles,
    PartnerLogo,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "اشتراك IPTV بجودة 4K | بث مباشر سريع ومستقر",
      meta: [
        {
          name: "description",
          content:
            "استمتع بأفضل اشتراك IPTV مع آلاف القنوات العربية والعالمية، القنوات الرياضية، الأفلام، المسلسلات، وخدمة بث مستقرة بجودة HD و4K على جميع الأجهزة.",
        },
        {
          name: "keywords",
          content:
            "اشتراك IPTV, IPTV 4K, IPTV HD, قنوات عربية, قنوات عالمية, بث مباشر, أفلام, مسلسلات, Smart TV, Android TV",
        },
        {
          property: "og:title",
          content: "اشتراك IPTV بجودة 4K | بث مباشر سريع ومستقر",
        },
        {
          property: "og:description",
          content:
            "شاهد آلاف القنوات العربية والعالمية والأفلام والمسلسلات بجودة عالية مع اشتراك IPTV مستقر وسريع.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/satellite-internet",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const bgImage = require("@/assets/images/footer-shape.png");

    return { bgImage };
  },
});
</script>